import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { DeviceType } from '@/src/types/deviceType'
import { TranslationFunction } from '@/src/types/translations'
import React from 'react'
import FilterHeader from './filterHeader'

interface FilterHeaderWrapperProps {
    tHeader: TranslationFunction<'header'>
    tCommon: TranslationFunction<'common'>
    deviceType: DeviceType
}

const FilterHeaderWrapper = React.memo(({ tHeader, tCommon, deviceType }: FilterHeaderWrapperProps) => {
    const { numberOfFlightsAfterFilter, totalFlights } = useSearchResults()
    return (
        <FilterHeader
            totalFlights={totalFlights}
            numberOfFlightsAfterFilter={numberOfFlightsAfterFilter}
            tHeader={tHeader}
            tCommon={tCommon}
            deviceType={deviceType}
        />
    )
})

FilterHeaderWrapper.displayName = 'FilterHeaderWrapper'

export default FilterHeaderWrapper
